import api from './api';

const service = {
    async searchSubmissionSalesPlan(params) {
        return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan`);
    },
    async updateSalesPlan(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/making`);
    },
    async DownloadSalesPlanXml(params) {
        return await api.get(`/files/xml/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan`)
    },
    async updateSubmissionOctto(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/upload`)
    },
    async searchReceptionSalesPlan(aggregator_id,params) {
        const baseUrl = `/aggregators/${aggregator_id}/electric_power/trading/plan/acceptance`;
        const paramsUrl = Object.entries(params).map((e) => {
            let key = e[0];
            let value = e[1];
            return `${key}=${value}`;
          }).join("&");
        const url = baseUrl + '?' + paramsUrl;
        return await api.get(url);
    },
    async searchAutoSubmissionConfig(params) {
        return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/electric_power/trading/plan/automatic_submission`)
    },
    async updateAutoSubmissionConfig(condition, payload){
        return await api.put(`/aggregators/${condition.aggregator_id}/areas/${condition.area_id}/electric_power/trading/plan/automatic_submission`, payload);
    },
    async searchSubmissionSalesPlanWeek(params) {
        return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/weeks_plan`);
    },
    async updateSalesPlanWeek(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/weeks_making`);
    },
    async DownloadSalesPlanXmlWeek(params) {
        return await api.get(`/files/xml/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/weeks_plan`)
    },
    async updateSubmissionOcttoWeek(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/weeks_upload`)
    },
    async searchSubmissionSalesPlanTwoDaysLater(params) {
        return await api.get(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/two_days_later_plan`);
    },
    async updateSalesPlanTwoDaysLater(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/two_days_later_making`);
    },
    async DownloadSalesPlanXmlTwoDaysLater(params) {
        return await api.get(`/files/xml/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/two_days_later_plan`)
    },
    async updateSubmissionOcttoTwoDaysLater(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan/two_days_later_upload`)
    },
    async downloadSalesPlan(params) {
        return await api.get(`/files/csv/aggregators/${params.aggregator_id}/areas/${params.area_id}/dates/${params.target_date}/electric_power/trading/plan`, { responseType:'blob', dataType:'binary' });
    },
}

export default service;
